import { createSelector } from 'reselect';
import { isShopSupportPickup } from '@utils/shop';
import { SHOP_DELIVERY_TYPE } from '@shared/constants';
import { getSearchAsObject } from '@shared/selectors';
import { QUERY_PARAM } from '@commons/constants';
import getShop from './getShop';

const getIsOccasionPickup = createSelector(
  getShop,
  getSearchAsObject,
  (shop, search) =>
    search &&
    search[QUERY_PARAM.OCCASION] === SHOP_DELIVERY_TYPE.PICK_UP &&
    isShopSupportPickup(shop),
);

export default getIsOccasionPickup;
